import { render, staticRenderFns } from "./MiniaturaComprimibile.vue?vue&type=template&id=4e6b61c6&scoped=true&"
import script from "./MiniaturaComprimibile.vue?vue&type=script&lang=js&"
export * from "./MiniaturaComprimibile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6b61c6",
  null
  
)

export default component.exports